import { Component, OnInit } from '@angular/core';
import { DashboardService } from '../dashboard.service';
import { StoreFilter, Lead } from '../../models/store.model';
import { NotificationBuilder } from '../../shared/notificationBuilder'
import { AuthenticationService } from '../../authentication/authentication.service';
import { Router, ActivatedRoute } from '@angular/router'

declare var $: any;
declare var swal: any;

@Component({
  selector: 'app-admin-lead',
  templateUrl: './admin-lead.component.html',
  styleUrls: ['./admin-lead.component.css']
})
export class AdminLeadComponent implements OnInit {
  loading = false
  constructor(private router: Router, private route: ActivatedRoute, private dashboardService: DashboardService, private authenticationService: AuthenticationService, private notificationBuilder: NotificationBuilder) {
  }
  //accounts: AccountModel[] = null
  leads: Lead[] = null
  storeFilter: StoreFilter

  ngOnInit() {
    this.storeFilter = new StoreFilter()
    var tempLead: Lead[] = new Array<Lead>()
    this.dashboardService.getAdminLeadNotAccounts().subscribe(data => {
      debugger

      data.forEach(function (store) {
        store.filterShow = true
      })
      this.leads = data;
    })
  }

  filterByNameEmail() {
    var keyname = this.storeFilter.byname
    this.leads.forEach(function (store) {
      debugger
      store.filterShow =(( store.name != null && (store.name.toLowerCase().indexOf(keyname.toLowerCase()) >= 0)) || (( store.email != null && store.email.toLowerCase().indexOf(keyname.toLowerCase()) >= 0)))
    });
  }

  deleteLead(email) {
    swal({
      type: 'warning',
      title: 'Tem certeza?',
      text: 'Esse Lead vai sumir PRA SEMPRE! Tem certeza?',
    }).then((result) => {
      if (result) {
        this.dashboardService.deleteLead(email).subscribe(data => {
          if (data) {
            this.notificationBuilder.showNotification('success', 1000, 'Lead Deletado')
          } else {
            this.notificationBuilder.showNotification('danger', 1000, 'nao foi possivel deletar')
          }
        })
      }
    })
  }

  showDetails(lead: Lead) {
    debugger
    if (lead != null) {
      swal({
        title: lead.name,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-success",
        html: `<table id="table" border=1>
                      <tbody>
                          <tr>
                              <td>Email</td>
                              <td>` + lead.email + `</td>
                          </tr>
                          <tr>
                              <td>Dominio</td>
                              <td>` + lead.domain + `</td>
                          </tr>
                          <tr>
                              <td>Telefone</td>
                              <td>` + lead.phone + `</td>
                          </tr>
              </tbody>
              </table>`
      })
    }
    else {
      swal({
        title: lead.name,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-success",
        html: `<table id="table" border=1>
                      <tbody>
                          <tr>
                              <td>ApiKey</td>
                              <td>1</td>
                          </tr>
                          <tr>
                              <td>Email</td>
                              <td>Fala com o Fernando! Deu Erro!</td>
                          </tr>
              </tbody>
              </table>`
      })
    }

  }

}
